import type { UnsentItemsResponse } from "../../types";

/**
 * HA-533 AC7 — whether removing the unsent items leaves the order empty, the case in which the
 * server cancels it. The same rule the server applies (RemoveUnsentItemsEndpoint): every item on the
 * order is among the unsent ones. HA-768: this used to be "were there any unsent items", which is
 * true whenever the dialog removes anything, so every removal said "Order cancelled".
 */
export function removalEmptiesOrder(
	orderItemIds: readonly string[],
	unsent: UnsentItemsResponse | undefined,
): boolean {
	if (!unsent || orderItemIds.length === 0) return false;

	const unsentIds = new Set(
		unsent.groups.flatMap((g) => g.items.map((i) => i.itemId)),
	);
	return orderItemIds.every((id) => unsentIds.has(id));
}
